import { constants } from '../constants';

export function validateEmail(email) {
    return constants.email.test(email);
}
